<template lang="html">
    <entity-page id="page__customer-group" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <z-input 
            v-model="group.name" label="Название" name="name" id="name"
            v-validate="'required|min:3'" v-bind:required="true" v-bind:error="errors.first('name')"
            data-vv-name="name" v-bind:data-vv-as="' '"
        ></z-input>

        <z-input 
            v-model="group.code" label="Символьный код" name="code" id="code"
            v-validate="'required|min:3'" v-bind:required="true" v-bind:error="errors.first('code')"
            data-vv-name="code" v-bind:data-vv-as="' '"
        ></z-input>

        <z-text-area 
            v-model="group.description" 
            v-bind:disabled="sending" name="description" id="description"
            label="Описание" v-bind:error="errors.first('description')"
            data-vv-name="description" v-bind:data-vv-as="' '"
        ></z-text-area>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZTextArea   from '@/components/ZTextArea';
    import ZButton     from '@/components/ZButton';
    import ZIcon       from '@/components/ZIcon';
    import ZIconButton from '@/components/ZIconButton';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: {ZInput, ZTextArea, ZButton, ZIcon, ZIconButton, EntityPage},
        data() {
            return {
                sending: false,
                group: {},
                groupDefault: {
                    name: null,
                    description: null,
                    sort: 100,
                    code: null
                }
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-customer-group-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        watch: {
            '$route.params.groupid'() {
                this.init();
            },
            'group'(newGroup, oldGroup) {
                if (JSON.stringify(newGroup) != JSON.stringify(oldGroup)) this.init();
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            async init() {
                this.$store.commit('openRightPanel');
                if (this.$route.params.groupid != 'new') await this.getGroup();
                else this.group = Object.assign({}, this.groupDefault);

                if (!this.group.id || this.group.id == 'new') this.$store.commit('setTitle', 'Группы клиентов | Новая группа');
                else this.$store.commit('setTitle', ('Группы клиентов | ' + this.group.name));
            },
            /**
             * Добавление группы пользователей
             */
            postGroup() {
                this.$store.commit('showProgressBar', 'load-customer-group-card');
                this.$store.dispatch('customers/addCustomerGroup', this.group).then(r => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'customer-groups');
                    this.$router.replace({name: 'CustomerGroup', params: {groupid: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-group-card'));
            },
            /**
             * Изменение группы пользователей
             */
            putGroup() {
                this.$store.commit('showProgressBar', 'load-customer-group-card');
                this.$store.dispatch('customers/updateCustomerGroup', this.group).then(r => {
                    if (!r) return;
                    this.init();
                    this.$root.$emit('reload-table', 'customer-groups');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-group-card'));
            },
            /**
            * Сохраняет изменения на карточке группы клиентов
            */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.groupid != 'new') this.putGroup();
                    else this.postGroup();
                })
            },
            /**
             * Получение группы клиентов
             */
            getGroup() {
                this.$store.commit('showProgressBar', 'load-customer-group-card');
                return this.$store.dispatch('customers/getCustomerGroup', {id: this.$route.params.groupid}).then(r => {
                    if (!r) return;
                    this.group = Object.assign({}, r);
                    return this.group;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-group-card'));
            },
            /**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
            back() {
                this.$router.push({name: 'CustomerGroups', query: this.$route.query});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Group.vue?3cd86b6b